<template>
  <f7-page id="page-account-home" name="account-home" @page:afterin="afterin">
    <f7-navbar class="view-mobile no-border">
      <f7-nav-left class="back-button">
        <f7-link
          icon-f7="chevron_left"
          @click="backButton"
          color="black"
        ></f7-link>
      </f7-nav-left>
      <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
      <div>
        <h2 class="ml-xs mt-md mb-0">{{$t('general-text-settings')}}</h2>
      </div>
      <div class="card mt-lg">
        <div>
          <h3 class="ml-md mt-md mb-0">{{$t('general-text-settings')}}</h3>
        </div>
        <div
          class="list simple-list no-hairlines-between card card-20 settings-toggle"
        >
          <ul>
            <li v-show="isShowFingerprint">
              <div class="display-flex align-items-center">
                <img
                  :src="require('@/assets/img/icon/icon-setting-biometric.svg')"
                  class="mr-sm filter-icon"
                />
                <span class="item-title">{{$t('general-text-biometric')}}</span>
              </div>
              <div>
                <label class="toggle toggle-init color-green2">
                  <input
                    type="checkbox"
                    :checked="isBiometricActive"
                    @change="onChangeFingerprint()"
                  />
                  <span class="toggle-icon"></span>
                </label>
              </div>
            </li>
            <li v-if="isShowFaceId">
              <div  class="display-flex align-items-center">
                <img
                  :src="require('@/assets/img/icon/icon-setting-face-id.svg')"
                  class="mr-sm filter-icon"
                />
                <span class="item-title">{{$t('general-text-face-id')}}</span>
              </div>
              <div>
                <label class="toggle toggle-init color-green2">
                  <input
                    type="checkbox"
                    :checked="isFaceIdActive"
                    @change="onChangeFaceId()"
                  />
                  <span class="toggle-icon"></span>
                </label>
              </div>
            </li>
            <!-- <li>
              <div class="display-flex align-items-center">
                <img
                  :src="require('@/assets/img/icon/icon-setting-dark-mode.svg')"
                  class="mr-sm filter-icon"
                />
                <span class="item-title">Dark mode</span>
              </div>
              <div>
                <label class="toggle toggle-init color-green2">
                  <input type="checkbox" @change="changeTheme" />
                  <span class="toggle-icon"></span>
                </label>
              </div>
            </li> -->
          </ul>
        </div>
      </div>
    </f7-block>
  </f7-page>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ApiService from "../services/api-main";

export default {
  data() {
    return {
      routerTo: "",
      customer: this.$store.state.customer,
      invitecode: "qwek2a2oaw",
      versionApp: "",
      isFaceIdActive: false,
      isBiometricActive: false,
      isShowFingerprint:false,
      isShowFaceId:false,
    };
  },
  mounted() {
    // Required for everypage. Toggle desktop-view footer.
    this.toggleFooterVisibility(false)
    this.$f7.$('.page-content').on('scroll', (e) => {
      this.toggleFooterVisibility(e.target)
    })
    if (window.Android || window.webkit) {
      this.checkBiometryAvaibility();
      this.$root.$once("handleBiometryType", (type) => {
          // 0 = None, 1 = Fingerprint, 2 = Face ID
          if(type== 1){
            this.isShowFingerprint=true;
          } else if(window.webkit && type== 2){
            this.isShowFaceId=true;
          }
        });
    }
    if (ApiService.getFormData("is_using_biometry")) {
      this.isFaceIdActive = true;
      this.isBiometricActive = true;
    }
  },
  computed: {
    ...mapGetters("auth", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode",
      "authenticationSuccess",
      "loggedIn",
    ]),
  },
  methods: {
    ...mapActions("auth", ["login", "logout"]),
    afterin(){
      window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
    },
    backButton() {
      this.$f7router.back({ transition: 'f7-push' });
    },
    onChangeFaceId() {
      if (this.isFaceIdActive) {
        this.isFaceIdActive = false;
        this.setCustomerUsingBiometry(this.$store.state.customer.customerId, 3);
      } else {
        this.isFaceIdActive = true;
        this.openDeviceBiometry();
        this.$root.$once("handleValidationBiometryStatus", (status) => {
          if(status) {
            this.$f7.toast.create({
              text: this.$t('general-faceid-has-been-activated'),
              position: 'bottom',
              closeTimeout: 3000,
            }).open()
          }
          this.isFaceIdActive = ApiService.getFormData("is_using_biometry");
        });
      }
    },
    onChangeFingerprint() {
      if (this.isBiometricActive) {
        this.isBiometricActive = false;
        this.setCustomerUsingBiometry(this.$store.state.customer.customerId, 3);
      } else {
        this.isBiometricActive = true;
        this.openDeviceBiometry();
        this.$root.$once("handleValidationBiometryStatus", (status) => {
          if(status) {
            this.$f7.toast.create({
              text: this.$t('general-fingerprint-has-been-activated'),
              position: 'bottom',
              closeTimeout: 3000,
            }).open()
          }
          this.isBiometricActive = ApiService.getFormData("is_using_biometry");
        });
      }
    },
    // changeTheme(e) {
    //   let $$ = this.Dom7;
    //   const el = $$("html");
    //   e.target.checked
    //     ? el.addClass("theme-dark")
    //     : el.removeClass("theme-dark");
    // },
  },
};
</script>
